<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  <router-link
    :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    class="member-name"
  >{{news.textParams[1]}}</router-link>
  {{$t('news.template.elected.valRBTS.p1')}}
  <router-link :to="{name: 'forum', params: {id: news.textParams[2]}}"
  >{{news.textParams[3]}}</router-link>
  {{$t('news.template.elected.valRBTS.p2')}}
  {{news.textParams[4]}}
  {{$t('news.template.elected.valRBTS.p3')}}
  {{news.textParams[5]}}.
</div>
</template>
